<template lang="pug">
    header.row.header
        div.container.property
            div.main
                div.mn__block.mn__logo
                    router-link.link(to="/")
                        img.logo(src="@/assets/logo.png")
                //mn__logo

                div.mn__menu
                    a(:href="/admin/" target="_blank" v-if="$store.state.isUserLoggedIn") ADMIN PANEL
                    router-link(:to="item.path" v-for="(item, index) in arrMenu" :key="index" v-if="item.visible") {{item.name}}
                //mn__menu

                div.mn__block.mn__addWords
                    button.btn.btn-white.light(@click="showPopup = !showPopup") Добавить слово
                //mn__addWords

                div.mn__block.mn__hamburger(@click="showMobHamburger = !showMobHamburger")
                    include ../snippets/menu.pug
            //main

            form-word(:toggle="showPopup" @close="onClose")

            div.nav__mobile(:class="{'is-active' : showMobHamburger}")
                div.wrapper.mScroll
                    div.mn__menu
                        a(:href="/admin/" target="_blank" v-if="$store.state.isUserLoggedIn") ADMIN PANEL
                        router-link(:to="item.path" v-for="(item, index) in arrMenu" :key="index" v-if="item.visible") {{item.name}}
        //container
    //header
</template>

<script>
    import formWord from '../components/FormWord';

    export default {
        name: "Header",
        data() {
            return {
                showPopup: false,
                showMobHamburger: false,
                arrMenu: [
                    {path: '/', name: 'Главная', visible: true},
                    {path: '/dictionary', name: 'Словарь', visible: true},
                    {path: '/favorites', name: 'Избранное', visible: true},
                    {path: '/about', name: 'О нас', visible: true}
                ]
            }
        },
        methods: {
            onClose(data) {
                this.showPopup = data
            },
        },
        components: {
            formWord
        }
    }
</script>
